import integrationsTranslations from './integrationsTranslations.js';

export default {
    integrations: integrationsTranslations,
};
